const translations = {
    emailAddressFieldPlaceholder: 'Email',
    firstNameFieldPlaceholder: 'First Name',
    lastNameFieldPlaceholder: 'Last Name',
    phoneNumberFieldPlaceholder: 'Phone Number',
    save: 'save'
};

export default translations;
